import { render, staticRenderFns } from "./GameColletion.vue?vue&type=template&id=7fd6f13a&scoped=true&"
import script from "./GameColletion.vue?vue&type=script&lang=ts&"
export * from "./GameColletion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd6f13a",
  null
  
)

export default component.exports